var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-header"},[_c('div',{staticClass:"text"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"question"},[_vm._v(_vm._s(_vm.question))])]),_c('img',{attrs:{"src":_vm.avatarUrl,"alt":"AI Avatar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }